import { useTranslationNameSpace, NAME_SPACES } from 'i18n/hooks';
import { GetInTouchSection } from 'modules/sections/components';
import { MobileSlider } from 'modules/sections/components/Slider/Slider.mobile';
import {
  FlexColumn,
  TEXT_TYPES,
  COLORS,
  TEXT_WEIGHTS,
  FlexRow,
  TEXT_SIZES,
  FlotableElement,
  Square,
  Text,
} from 'modules/ui/components';
import { Animatable, ANIMATIONS_TYPES } from 'modules/ui/components/Animatable';
import { PageTitle } from 'modules/ui/components/PageTitle';
import {
  subCards,
  points,
  sliderMobileStyles,
  sliderTabsMobileStyles,
} from './utils';

export const MobileDesign = () => {
  const { t } = useTranslationNameSpace(NAME_SPACES.PAGES);

  return (
    <FlexColumn w="100%" h="100%">
      <PageTitle title={t('design.title')} />
      <FlexColumn
        w="100%"
        alignItems="center"
        position="relative"
        bgSize="cover"
        bg="url(./assets/backgrounds/background-4.png)"
      >
        <FlexColumn w="80%" alignItems="center">
          <FlexColumn w="100%" alignItems="center">
            <Text
              m="35px 0 26px 0"
              size="36px"
              type={TEXT_TYPES.title}
              color={COLORS.lightBlue}
              weight={TEXT_WEIGHTS.bolder}
              lineHeight="35px"
              textAlign="center"
            >
              {t('design.cards.0.title')}
            </Text>
            <Text
              w="100%"
              size="28px"
              type={TEXT_TYPES.text}
              color={COLORS.white}
              weight={TEXT_WEIGHTS.tiny}
              textAlign="center"
              whiteSpace="pre-wrap"
              letterSpacing="0.88px"
              lineHeight="40px"
            >
              {t('design.cards.0.text')}
            </Text>
          </FlexColumn>
          <FlexRow m="100px 0">
            <img
              src="./assets/design/card-0.png"
              alt="story"
              width={126}
              height={126}
            />
          </FlexRow>
          <FlexColumn m="35px 0" w="100%" justifyContent="center">
            <MobileSlider
              styles={sliderMobileStyles}
              slides={subCards.map((_, i) => (
                <FlexColumn w="100%" alignItems="center" m="60px auto">
                  <FlexColumn w="100%" alignItems="center">
                    <img
                      src={`./assets/design/subCard-${i}.png`}
                      alt="sub-card"
                    />
                    <Text
                      m="35px 0"
                      size="35px"
                      letterSpacing="1.4px"
                      type={TEXT_TYPES.title}
                      color={COLORS.lightBlue}
                      weight={TEXT_WEIGHTS.bolder}
                      whiteSpace="pre-wrap"
                      lineHeight="32px"
                      textAlign="center"
                    >
                      {t(`design.subCards.${i}.title`)}
                    </Text>
                    <Text
                      w="100%"
                      size={TEXT_SIZES.s}
                      type={TEXT_TYPES.text}
                      color={COLORS.white}
                      weight={TEXT_WEIGHTS.tiny}
                      textAlign="center"
                      letterSpacing="0.56px"
                      lineHeight="25px"
                      whiteSpace="pre-wrap"
                    >
                      {t(`design.subCards.${i}.text`)}
                    </Text>
                  </FlexColumn>
                </FlexColumn>
              ))}
            />
          </FlexColumn>
          <FlexColumn m="50px 0" w="100%" alignItems="center">
            <img
              src="./assets/design/card-1.png"
              alt="story"
              width={115}
              height={128}
            />
            <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
              <FlexColumn w="100%" m="30px 0 0 0">
                <Text
                  size="35px"
                  letterSpacing="1.4px"
                  type={TEXT_TYPES.title}
                  color={COLORS.lightBlue}
                  weight={TEXT_WEIGHTS.bolder}
                  whiteSpace="pre-wrap"
                  textAlign="center"
                >
                  {t(`design.cards.1.title`)}
                </Text>
                <Text
                  m="15px 0"
                  size="22px"
                  type={TEXT_TYPES.text}
                  color={COLORS.white}
                  weight={TEXT_WEIGHTS.tiny}
                  letterSpacing="0.56px"
                  lineHeight="25px"
                  whiteSpace="pre-wrap"
                  textAlign="center"
                >
                  {t(`design.cards.1.text`)}
                </Text>
              </FlexColumn>
            </Animatable>
          </FlexColumn>
        </FlexColumn>
        <FlexColumn
          w="100%"
          alignItems="center"
          bg="rgba(138, 245, 245, 0.1)"
          p="30px 0 20px 0"
        >
          <img
            src="./assets/design/card-2.png"
            alt="story"
            width={63}
            height={111}
          />
          <FlexColumn w="100%" alignItems="center">
            <Text
              w="90%"
              m="20px 0"
              size="20px"
              letterSpacing="1.4px"
              type={TEXT_TYPES.title}
              color={COLORS.lightBlue}
              weight={TEXT_WEIGHTS.bolder}
              whiteSpace="pre-wrap"
              textAlign="center"
            >
              {t(`design.cards.2.title`)}
            </Text>
            <Text
              m="15px 0"
              w="90%"
              size="25px"
              type={TEXT_TYPES.text}
              color={COLORS.white}
              weight={TEXT_WEIGHTS.tiny}
              letterSpacing="0.56px"
              lineHeight="30px"
              whiteSpace="pre-wrap"
              textAlign="center"
            >
              {t(`design.cards.2.text`)}
            </Text>
          </FlexColumn>
        </FlexColumn>
        <FlexColumn w="80%" alignItems="center" m="30px 0">
          <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
            <FlexColumn w="100%" alignItems="center">
              <Text
                m="20px 0"
                size="30px"
                letterSpacing="1.4px"
                type={TEXT_TYPES.title}
                color={COLORS.lightBlue}
                weight={TEXT_WEIGHTS.bolder}
                whiteSpace="pre-wrap"
                textAlign="center"
              >
                {t(`design.cards.3.title`)}
              </Text>
              <Text
                m="15px 0"
                size="22px"
                type={TEXT_TYPES.text}
                color={COLORS.white}
                weight={TEXT_WEIGHTS.tiny}
                letterSpacing="0.56px"
                lineHeight="25px"
                whiteSpace="pre-wrap"
                textAlign="center"
              >
                {t(`design.cards.3.text`)}
              </Text>
            </FlexColumn>
          </Animatable>
        </FlexColumn>
        <FlexColumn
          w="100%"
          alignItems="center"
          justifyContent="center"
          p="20px 0 50px 0"
          bg={'rgba(79, 255, 255, 0.001)'}
        >
          <MobileSlider
            styles={sliderTabsMobileStyles}
            slides={points.map((_, i) => (
              <FlexColumn w="100%" alignItems="center" m="35px 0">
                <img src={`./assets/design/points-${i}.png`} alt="story" />
                <FlexColumn w="100%" alignItems="center">
                  <Text
                    m="30px 0 10px 0"
                    size="20px"
                    letterSpacing="1.4px"
                    type={TEXT_TYPES.title}
                    color={COLORS.lightBlue}
                    weight={TEXT_WEIGHTS.bolder}
                    whiteSpace="pre-wrap"
                    textAlign="center"
                  >
                    {t(`design.points.${i}.title`)}
                  </Text>
                </FlexColumn>
              </FlexColumn>
            ))}
          />
        </FlexColumn>
        <GetInTouchSection title={t(`tv.contactSection.title`) as string} />
        <FlotableElement left="-20%" top="30%">
          <Square zIndex="1" size="30vw" />
        </FlotableElement>
      </FlexColumn>
    </FlexColumn>
  );
};
